export default "__VITE_ASSET__DDpQdyyg__"